
import MultiSceneCommand from './MultiSceneCommand';
import measureClear from './measureClear';

export default class MultiSceneCommandMeasureClear extends MultiSceneCommand {

    constructor(options) {
        super(options);
        this._name = 'MEASURE_CLEAR';
    }

    execute(multiSceneViewer, params) {
        measureClear(multiSceneViewer);
    }
}
